import api, { ApiCallReturn } from '../api';

export const getUserPromotionFirstUnread = (): ApiCallReturn => api.get('/promotions/first-unread');
export const postPromotionRead = (promotionId: number): ApiCallReturn => api.post(`/promotions/${promotionId}/read`);
